<template>
  <div>
    <!-- HEADER -->
    <v-layout>
      <v-flex lg2>
        <rating-frame
          :rating="subcontractor.rating"/>
      </v-flex>
      <v-spacer/>
      <v-flex lg6>
        <!-- ROW 1.1: NAME, EDIT BUTTON -->
        <v-layout
          align-center
          justify-space-between>
          <span class="headline">
            {{ subcontractor.name }}
          </span>
          <v-btn
            class="ma-0"
            flat
            icon
            @click="dialog = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-layout>
        <!-- ROW 1.2: STATES -->
        <v-layout
          class="mb-2"
          align-center
          justify-space-between>
          <v-flex shrink>
            <v-layout>
              <v-chip
                v-for="s in subcontractor.states"
                :key="s.name"
                label
                small
                disabled
                class="ml-0 mr-2">
                {{ s.name }}
              </v-chip>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider/>
        <!-- ROW 2: DETAILS -->
        <v-layout class="mt-5">
          <v-flex>
            <subcontractor-details
              :dtls="subcontractor.details"
              @refresh="refresh"/>
          </v-flex>
        </v-layout>
        <!-- ROW 3: FRANCHISES TABLE -->
        <v-layout class="mt-4">
          <v-flex>
            <franchises-table/>
          </v-flex>
        </v-layout>
        <!-- ROW 4: RATES TABLE -->
        <v-layout class="mt-4">
          <v-flex>
            <rates-table
              :loading="loading"
              :rates="subcontractor.rates"
              @refresh="refresh"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex lg3/>
    </v-layout>
    <!-- EDIT DIALOG -->
    <edit-dialog
      v-model="dialog"
      :subcontractor="subcontractor"
      @refresh="refresh"/>
  </div>
</template>

<script>
import SubcontractorDetails from "./Subcontractor/Details";
import EditDialog from "./Subcontractor/EditDialog";
import RatesTable from "./Subcontractor/RatesTable";
import RatingFrame from "./SharedComponents/RatingFrame";
import FranchisesTable from "./Subcontractor/FranchisesTable";

export default {
  components: {
    // Details card
    SubcontractorDetails,
    EditDialog,
    RatingFrame,
    // Table with all rates
    RatesTable,
    // Table with all franchises
    FranchisesTable
  },
  filters: {
    displayRating (rating) {
      return rating ? parseFloat(rating).toFixed(1) : "";
    }
  },
  data () {
    return {
      // Boolean to toggle the edit dialog
      dialog: false,
      loading: false,
      subcontractor: {
        id: 0,
        name: "< Name >",
        rating: null,
        rates: [],
        details: []
      }
    };
  },
  created () {
    // Get information on the subcontractor to be edited
    const { id } = this.$route.params;
    this.loading = true;
    this.$http.get(`/api/subcontractors/${id}`).
      then((r) => Object.assign(this.subcontractor, r.data)).
      finally(() => this.loading = false);
  },
  methods: {
    refresh () {
      const { id } = this.$route.params;
      this.$http.
        get(`/api/subcontractors/${id}`).
        then((r) => Object.assign(this.subcontractor, r.data));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Subcontractor.vue